export default __webpack_public_path__ + "static/media/b1.562b588a.jpg";